"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _core = require("@material-ui/core");
var _contexts = require("../../contexts");
var _services = require("../../services");
var _styles = _interopRequireDefault(require("./styles"));
var _CopyDiv = _interopRequireDefault(require("./CopyDiv"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable react/jsx-no-bind */
var DIALOG_STATE_KEY = '__copyTextDialog';
var CopyTextDialog = () => {
  var [isFirstCopy, setIsFirstCopy] = (0, _react.useState)(true);
  var {
    openCopyTextDialog,
    setOpenCopyTextDialog,
    copyValue,
    reference,
    getRemainingChars,
    setCopyValue,
    getPercentageCharsCopied
  } = (0, _react.useContext)(_contexts.CopyrightContext);
  var {
    applicationToken,
    sessionToken,
    userId,
    uuid,
    getBookTotalChars
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var service = (0, _services.CharactersCopyService)(applicationToken, sessionToken);
  (0, _react.useEffect)(() => {
    if (openCopyTextDialog) {
      window.history.pushState({
        [DIALOG_STATE_KEY]: true
      }, '');
    }
  }, [openCopyTextDialog]);
  (0, _react.useEffect)(() => {
    function onPopState() {
      if (openCopyTextDialog) {
        setOpenCopyTextDialog(false);
        setIsFirstCopy(true);
      }
    }
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [openCopyTextDialog, setOpenCopyTextDialog]);
  var classes = (0, _styles.default)();
  var matches = (0, _core.useMediaQuery)('(min-width:769px)');
  function onCopy(_x) {
    return _onCopy.apply(this, arguments);
  }
  function _onCopy() {
    _onCopy = _asyncToGenerator(function* (value) {
      if (!isFirstCopy) return;
      setIsFirstCopy(false);
      var remainingChars = yield getRemainingChars();
      var totalCharacters = getBookTotalChars();
      var chars = value.length > remainingChars ? remainingChars : value.length;
      yield service.setCharactersCopied(userId, uuid, chars, totalCharacters);
      var newCopyValue = yield getPercentageCharsCopied();
      setCopyValue(newCopyValue);
    });
    return _onCopy.apply(this, arguments);
  }
  function onClose() {
    var _window$history$state;
    if ((_window$history$state = window.history.state) !== null && _window$history$state !== void 0 && _window$history$state[DIALOG_STATE_KEY]) {
      window.history.replaceState(null, '');
    }
    setOpenCopyTextDialog(false);
    setIsFirstCopy(true);
  }
  return /*#__PURE__*/_react.default.createElement(_saraivaUi.Dialog, {
    open: openCopyTextDialog,
    size: "md",
    title: "Copiar",
    primaryButton: "fechar",
    handleConfirm: onClose,
    handleClose: onClose,
    confirmWithoutCheck: onClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    onContextMenu: e => e.preventDefault(),
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_CopyDiv.default, {
    title: "Trecho selecionado",
    reference: reference.trim(),
    onCopy: onCopy
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_CopyDiv.default, {
    abntProp: true,
    title: "Cita\xE7\xE3o direta norma ABNT",
    reference: reference.trim(),
    onCopy: onCopy
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement("h6", {
    className: matches ? classes.label : classes.labelMobile
  }, "Limite de c\xF3pia deste livro"), /*#__PURE__*/_react.default.createElement(_saraivaUi.ProgressBar, {
    className: classes.bar,
    size: "full",
    color: "secondary",
    small: true,
    value: copyValue,
    limit: true
  })));
};
var _default = exports.default = CopyTextDialog;